import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoOficioSegundaViaPlaca } from './types';

export const INITIAL_STATE: impressaoOficioSegundaViaPlaca = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoOficioSegundaViaPlaca {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_OFICIO_SEGUNDA_VIA_PLACA_REQUEST: {
				break;
			}

			case Types.IMPRESSAO_OFICIO_SEGUNDA_VIA_PLACA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_OFICIO_SEGUNDA_VIA_PLACA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
		return draft;
	});
}
